<template>
  <div class="rightTop">
    <div
      class="title"
      :style="$route.params.dbcode != 1 ? 'border-bottom: 1px solid #08396A;' : 'border-bottom:none;'"
    >
      <span>{{companyFullName}}</span>
      <!-- <div class="button" @click="addCollect">{{storeUpState ? '取消收藏' : '加入收藏'}}</div> -->
    </div>
    <!-- 有切换，待改 -->
    <div class="con rightTop_companyList" v-if="$route.params.dbcode != 1">
      <!-- <p
        v-for="(item,index) in rightTop"
        :key="index"
        @click="changeSelectedCompany(index)"
      >{{item.marketName}} | {{item.className}} | {{item.companyStockCode}} | {{item.stockName}}</p> -->
    </div>
  </div>
</template>
<script>
import api from "@/../static/common/api/api.js";
export default {
  props: {},
  components: {},
  data() {
    return {
      companyFullName: "",
      rightTop: [],
      selectCompanyInfo: {}, //当前选中的股票信息
      params: {}, //点击收藏，判断收藏状态的参数集合
      storeUpState: false, //判断当前股票收藏状态
      collectId: 0
    };
  },
  computed: {},
  methods: {
    getInfoByCreditCode() {
      let creditCode = this.$route.query.creditCode;
      let dbcode = this.$route.params.dbcode;
      if (creditCode && dbcode == 2) {
        api.baseInfoTableCompanyDetail(creditCode).then(res => {
          this.companyFullName = res.data[0].companyFullName;
          this.rightTop = res.data;
          setTimeout(() => {
            $(".rightTop_companyList p")
              .eq(0)
              .css("color", "#3583ED");
          }, 200);
          this.$emit("data", [res.data[0],'123']);
        });
      } else {
        let companyName = JSON.parse(sessionStorage.getItem("companyName"));
        this.companyFullName = companyName;
      }
    },
    //切换当前选中的公司
    changeSelectedCompany(index) {
      $(".rightTop_companyList p").css("color", "#fff");
      $(".rightTop_companyList p")
        .eq(index)
        .css("color", "#3583ED");
      // this.ifStoreUpFn(index);
      this.$emit("data", [this.rightTop[index]]);
    },
    //判断是否已经收藏还是未收藏
    // ifStoreUpFn(num) {
    //   let _this = this;
    //   let usersInfo = localStorage.getItem("usersInfo")
    //     ? JSON.parse(localStorage.getItem("usersInfo"))
    //     : "";
    //   let params = {
    //     // userId: usersInfo.userId ? usersInfo.userId : '',
    //     dbCode:
    //       this.$route.params.dbcode == 2
    //         ? 0
    //         : this.$route.params.dbcode == 1
    //         ? 1
    //         : "",
    //     enterpriseCode:
    //       this.$route.params.dbcode == 2
    //         ? this.rightTop[num].enterpriseCode
    //         : "",
    //     uniqueCode:
    //       this.$route.params.dbcode == 1 ? this.$route.query.creditCode : ""
    //   };
    //   this.params = params;
    //   api.ifStoreup(params).then(res => {
    //     _this.storeUpState = res.data.collectFlag;
    //     _this.collectId = res.data.collectId;
    //   });
    // },
    // 加入收藏
    addCollect() {
      // 收藏上市公司的时候  uniqueCode为空
      // 收藏医药公司的时候  enterpriseCode为空
      // let usersInfo = localStorage.getItem('usersInfo') ? JSON.parse(localStorage.getItem('usersInfo')) : '';
      // let params = {
      //   userId: usersInfo.userId ? usersInfo.userId : '',
      //   dbCode: this.$route.params.dbcode,
      //   enterpriseCode: this.$route.params.dbcode == 2 ? this.rightTop.enterpriseCode : '',
      //   uniqueCode:this.$route.params.dbcode == 1 ? this.$route.query.creditCode : ''
      // }
      let _this = this;
      if (this.storeUpState) {
        //已经是被收藏状态，取消收藏
        let params = {
          collectId: _this.collectId
        };
        api.deleteStoreup(params).then(res => {
          let data = res.data;
          _this.storeUpState = false;
        });
      } else {
        //未收藏状态，添加收藏
        api.addStoreup(this.params).then(res => {
          _this.storeUpState = true;
        });
        // 埋点
        try {
          //LogCollection.contents["key"]="value";
          //0：浏览（已在浏览器关闭、刷新、页面跳转时自动执行，此处可提前使之执行。）
          //2：收藏
          //3：下载
          //4：分享
          //5：购买
          //6：登录
          //7：注册
          //9：搜索
          //10：复制
          //11：点赞
          //12：评论
          LogCollection.send(2);
        } catch (e) {}
      }
      // 埋点
      try {
        //LogCollection.contents["key"]="value";
        //0：浏览（已在浏览器关闭、刷新、页面跳转时自动执行，此处可提前使之执行。）
        //2：收藏
        //3：下载
        //4：分享
        //5：购买
        //6：登录
        //7：注册
        //9：搜索
        //10：复制
        //11：点赞
        //12：评论
        LogCollection.send(2);
      } catch (e) {}
    }
  },
  created() {},
  mounted() {
    this.getInfoByCreditCode();
    setTimeout(() => {
      this.changeSelectedCompany(0);
    }, 800);
  }
};
</script>
<style scoped lang="less">
.rightTop {
  width: auto;
  // height: 129px;
  margin-right: 20px;
  border-radius: 2px;
  display: flex;
  flex-direction: column;
  padding: 0 20px 10px;
  .title {
    height: 50px;
    line-height: 50px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    span {
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #dfecf7;
    }
    .button {
      width: 88px;
      height: 30px;
      line-height: 30px;
      text-align: center;
      background: #3583ed;
      border-radius: 2px;
      color: #fefefe;
      font-size: 12px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      cursor: pointer;
    }
  }
  .con {
    width: auto;
    flex-grow: 1;
    font-size: 14px;
    font-family: Microsoft YaHei;
    color: #fff;
    display: flex;
    flex-direction: column;
    p {
      padding-top: 10px;
      cursor: pointer;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/rightTop.vue